import { RegistryWidgetsType } from "@rjsf/utils";
import MallsSelectWidget from "./MallsSelectWidget";
import CustomisedSelectWidget from "./CustomisedSelectWidget";
import RetailersSelectWidget from "./RetailersSelectWidget";
import StoresSelectWidget from "./StoresSelectWidget";

const widgets: RegistryWidgetsType = {
  CustomisedSelectWidget: CustomisedSelectWidget,
  MallsSelectWidget: MallsSelectWidget,
  RetailersSelectWidget: RetailersSelectWidget,
  StoresSelectWidget:StoresSelectWidget,
};

export default widgets;
